module.exports = __webpack_public_path__ + "static/img/thumb2.1786799.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/thumbnails/thumb2.jpg
// module id = 643
// module chunks = 0